import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import FsLightbox from "fslightbox-react";
import { useState } from "react";
import { useMemo } from "react";

import Caro from '../Caro';
const Gallery = () => {
    // Gallery Lightbox State
    const [galleryToggler, setGalleryToggler] = useState(false);
    const [gallerySlide, setGallerySlide] = useState(1);

    // Highlight Lightbox State
    const [highlightToggler, setHighlightToggler] = useState(false);
    const [highlightSlide, setHighlightSlide] = useState(1);
    const slabs = [
        {
            weight: "2 Kg & Above",
            price: 950,
            transit: "6-8 working days",
            image: "/assets/gallery/2026/industry-visit-1.jpg",
        },
        {
            weight: "4 Kg & Above",
            price: 900,
            transit: "6-8 working days",
            image: "/assets/gallery/2026/industry-visit-2.jpg",
        },
        {
            weight: "2 Kg & Above",
            price: 950,
            transit: "6-8 working days",
            image: "/assets/gallery/2026/session-1.jpg",
        },
        {
            weight: "4 Kg & Above",
            price: 900,
            transit: "6-8 working days",
            image: "/assets/gallery/2026/session-2.jpg",
        },
        {
            weight: "2 Kg & Above",
            price: 950,
            transit: "6-8 working days",
            image: "/assets/gallery/lmp-gallery-images-2026-1.jpg",
        },
        {
            weight: "4 Kg & Above",
            price: 900,
            transit: "6-8 working days",
            image: "/assets/gallery/lmp-gallery-images-2026-2.jpg",
        },
        {
            weight: "2 Kg & Above",
            price: 950,
            transit: "6-8 working days",
            image: "/assets/gallery/lmp-gallery-images-2026-1.jpg",
        },
        {
            weight: "4 Kg & Above",
            price: 900,
            transit: "6-8 working days",
            image: "/assets/gallery/lmp-gallery-images-2026-2.jpg",
        },

    ];
    const galleryImages = useMemo(() => ([
        "/assets/gallery/2026/industry-visit-1.jpg",
        "/assets/gallery/2026/industry-visit-2.jpg",
        "/assets/gallery/2026/industry-visit-3.jpg",
        "/assets/gallery/2026/industry-visit-4.jpg",
        "/assets/gallery/2026/session-1.jpg",
        "/assets/gallery/2026/session-2.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-1.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-2.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-3.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-4.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-5.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-6.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-7.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-8.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-9.jpg",
        "/assets/gallery/2026/lmp-gallery-2026-10.jpg",
        "/assets/gallery/lmp-gallery-images-2026-1.jpg",
        "/assets/gallery/lmp-gallery-images-2026-2.jpg",
        "/assets/gallery/lmp-gallery-images-2026-3.jpg",
        "/assets/gallery/lmp-gallery-images-2026-4.jpg",
        "/assets/gallery/lmp-gallery-images-2026-5.jpg",
        "/assets/gallery/lmp-gallery-images-2026-6.jpg",
        "/assets/gallery/lmp-gallery-images-2026-7.jpg",
        "/assets/gallery/lmp-gallery-images-2026-8.jpg",
        "/assets/gallery/lmp-gallery-images-2026-9.jpg",
        "/assets/gallery/lmp-gallery-images-2026-10.jpg",
        "/assets/gallery/lmp-gallery-images-2026-11.jpg",
        "/assets/gallery/lmp-gallery-images-2026-12.jpg",
        "/assets/gallery/lmp-gallery-images-2026-13.jpg",
        "/assets/gallery/lmp-gallery-images-2026-14.jpg",
        "/assets/gallery/lmp-gallery-images-2026-15.jpg",
        "/assets/gallery/lmp-gallery-images-2026-16.jpg",
        "/assets/gallery/lmp-gallery-images-2026-17.jpg",
        "/assets/gallery/lmp-gallery-images-2026-18.jpg",
        "/assets/gallery/lmp-gallery-images-2026-19.jpg",
        "/assets/gallery/lmp-gallery-images-2026-20.jpg",
        "/assets/gallery/lmp-gallery-images-2026-21.jpg",
        "/assets/gallery/lmp-gallery-images-2026-22.jpg",
        "/assets/gallery/lmp-gallery-images-2026-23.jpg",
        "/assets/gallery/lmp-gallery-images-2026-24.jpg",
        "/assets/gallery/lmp-gallery-images-2026-25.jpg",
        "/assets/gallery/lmp-gallery-images-2026-26.jpg",
        "/assets/gallery/lmp-latest-batch-2025-1.jpg",
        "/assets/gallery/lmp-latest-batch-2025-2.jpg",
        "/assets/gallery/lmp-latest-batch-2025-3.jpg",
        "/assets/gallery/lmp-latest-batch-2025-4.jpg",
    ]), []);

    const highlightImages = useMemo(() => ([
        "/assets/gallery/highlight/lmp-gallery-images-2026-1.jpg",
        "/assets/gallery/highlight/lmp-gallery-images-2026-2.jpg",

    ]), []);

    const openGallery = (index) => {
        setGallerySlide(index + 1);
        setGalleryToggler(prev => !prev);
    };

    const openHighlight = (index) => {
        setHighlightSlide(index + 1);
        setHighlightToggler(prev => !prev);
    };


    return (
        <section className="mijsc-programs">
            <Helmet>
                <title>Gallery | Our Mission & Vision</title>
                <meta
                    name="description"
                    content="Learn more about MIJSC, our mission, vision, and commitment to excellence."
                />
            </Helmet>

            <BreadCrumbs />

            <div className=' w-[94%] text-justify'>
                <section className='w-full h-fit md:mx-10 mx-5' >
                    <h1 className="md:text-4xl text-lg my-10 font-semibold uppercase text-left"> Gallery  <br />
                        <span className="text-green-600">LMP</span>
                    </h1>
                </section>
            </div>


            {/* ===== Highlights Section ===== */}
            <h2 className="text-3xl font-bold text-center mb-2">
                Highlights
            </h2>

            {/* <div className="px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-7">
                {highlightImages.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={`Highlight ${index + 1}`}
                        onClick={() => openHighlight(index)}
                        className="rounded-xl w-full h-64 object-cover cursor-pointer transition-all duration-700 hover:scale-105"
                    />
                ))}
            </div> */}
            <div>

                <Caro slabs={slabs} />

            </div>

            <FsLightbox
                toggler={highlightToggler}
                slide={highlightSlide}
                sources={highlightImages}
            />

            {/* ===== Gallery Section ===== */}
            <h2 className="text-3xl font-bold text-center mt-16 ">
                Gallery
            </h2>
            <p className="text-gray-600 text-sm  mb-10 mt-4">Moments from LMP Conclave at IIMB </p>

            <div className="px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7 mb-20">
                {galleryImages.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={`Gallery ${index + 1}`}
                        onClick={() => openGallery(index)}
                        className="rounded-xl w-full h-64 object-cover cursor-pointer transition-all duration-700 hover:scale-105"
                    />
                ))}
            </div>

            <FsLightbox
                toggler={galleryToggler}
                slide={gallerySlide}
                sources={galleryImages}
            />





        </section>
    );
};

export default Gallery;
